export const SUB_ITEMS_FIELD = 'actualItems';
export const EB_SUB_ITEMS_FIELD = 'assignedEquipments';
export const DATA_ITEM_KEY = 'id';
export const EXPAND_FIELD = 'expanded';
export const MODE_FIELD = 'inEdit';
export const ADD_FIELD = 'isNew';
export const IS_ACTUAL_ID_ADDITION = 'isActualIdAddition';
export const TREELIST_CONFIG = {
  sortable: false,
  reorderable: false,
  resizable: true,
  scrollable: 'virtual',
  rowHeight: 50,
};
export const MIN_SEARCH_TERM_LENGTH = 3;
export const EB_FIELDS_TO_OMIT = [MODE_FIELD, ADD_FIELD, EXPAND_FIELD, 'parentEquipPlannedId', 'parentId', 'isEquipmentSpecification'];
export const EB_PARENT_FIELDS_TO_OMIT = [MODE_FIELD, ADD_FIELD, EXPAND_FIELD, SUB_ITEMS_FIELD, 'parentEquipPlannedId', 'parentId', 'actualId', 'plannedId', 'calDueDate', 'pmDueDate'];
